/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForgotPasswordViewModel
 */
export interface ForgotPasswordViewModel {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordViewModel
     */
    email: string;
}

export function ForgotPasswordViewModelFromJSON(json: any): ForgotPasswordViewModel {
    return ForgotPasswordViewModelFromJSONTyped(json, false);
}

export function ForgotPasswordViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForgotPasswordViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ForgotPasswordViewModelToJSON(value?: ForgotPasswordViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

